"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleTextFilterFn = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.string.starts-with.js");
require("core-js/modules/es.regexp.to-string.js");
const SimpleTextFilterFn = (rows, id, filterValue) => rows.filter(row => {
  const rowValue = row.values[id];
  return rowValue !== undefined ? rowValue.toString().toLowerCase().startsWith(filterValue.toString().toLowerCase()) : true;
});
exports.SimpleTextFilterFn = SimpleTextFilterFn;